import { render, staticRenderFns } from "./Basic-Details.vue?vue&type=template&id=61b8d070"
import script from "./Basic-Details.vue?vue&type=script&lang=js"
export * from "./Basic-Details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports